import { useAppDispatch } from 'state/store';
import { updateSelectedMetricId } from 'state/store/reducers/metricsSlice';

export type UseMetricsActions = {
  setSelectedMetricId: (id: string) => void;
};

export const useMetricsActions = (): UseMetricsActions => {
  const dispatch = useAppDispatch();

  return {
    setSelectedMetricId: (id: string) => {
      dispatch(updateSelectedMetricId(id));
    },
  };
};
